var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoarow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7778 5.93052C14.0463 6.199 14.0463 6.63431 13.7778 6.90279L9.68068 11L13.7778 15.0972C14.0463 15.3657 14.0463 15.8009 13.7778 16.0694C13.5093 16.3379 13.0741 16.3379 12.8056 16.0694L8.22224 11.4861C8.09331 11.3572 8.02087 11.1823 8.02087 11C8.02087 10.8177 8.09331 10.6428 8.22224 10.5139L12.8056 5.93052C13.0741 5.66204 13.5093 5.66204 13.7778 5.93052Z",
    fill: "#14489F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoarow);
export default __webpack_public_path__ + "static/media/coarow.8278152edc0703326391a9f51f89f637.svg";
export { ForwardRef as ReactComponent };